import { Theme as e } from "../components/Theme/ThemeContext.js";
import t, { applyTheme as n } from "@jetbrains/ring-ui-built/components/global/theme.js";
//#region src/utils/theme.ts
var r = (t) => t === e.dark, i = (t) => t === e.auto, a = (e, t) => i(e) && t ? t : e, o = () => typeof window < "u" && !!window.matchMedia, s = (e, t, n) => {
	if (i(e)) n.current && document.head.contains(n.current) && (document.head.removeChild(n.current), n.current = null);
	else if (n.current) n.current?.setAttribute("content", t);
	else {
		let e = document.querySelectorAll("meta[name=\"theme-color\"]"), r = document.createElement("meta");
		r.name = "theme-color", r.content = t, n.current = r, e.length === 2 && e[0].before(r);
	}
}, c = (e) => {
	let { body: i } = document;
	i.classList.add("bodyQodanaBlocks"), r(e) ? (i.classList.add("bodyQodanaBlocks_dark"), n(t.DARK, i)) : (i.classList.remove("bodyQodanaBlocks_dark"), n(t.LIGHT, i));
};
//#endregion
export { a as getCurrentThemeColor, i as isAuto, r as isDark, o as isMatchMediaAvailable, c as updateBodyClass, s as updateMetaThemeColor };
